import mixin from "@/mixin/index.js"
const _shuffle = mixin.methods._shuffle;
export default {
    loading: state => state.loading,
    getCalculatorModel: state => state.calculatorModel,
    alert: state => state.alert,
    user: state => state.user,
    isPremium: state => !!state.user && !!state.user.premiumStatus,
    isVeterinaryProfessional: state => state.user && state.user.questions
        && state.user.questions.veterinaryStatus === parseInt(process.env.VUE_APP_VETERINARY_STATUS_PROFESSIONAL),
    entitlements: state => state.user.entitlements,
    toggles: state => state.user ? state.user.toggles : null,
    veterinaryColleges: state => state.veterinaryColleges,
    reference: state => state.reference,
    isDrugsManagement: state => state.isDrugsManagement,
    userSection: state => state.userSection,
    link_redirect: state => state.link_redirect,
    confirmModel: state => state.confirmModel,
    getStepper: state => state.stepper,
    getStepperTotal: state => state.stepperTotal,
    getStepperData: state => state.stepperData,
    getStepperModel: state => state.stepperModel,
    homeAdds: state => state.homeAdds,
    emailConfirmation: state => state.emailConfirmation,
    products: state => state.products,
    purchasesModel: state => state.purchasesModel,
    synonyms: state => state.synonyms,
    breadcrumbs: state => state.breadcrumbs,
    sectionsPanelOpen: state => state.sectionsPanelOpen
}